<div [class]="hideBackground ?  'loader-background hide-background' : 'loader-background'">
    <div class="spinner-wrapper">
        <img class='spinner-loader' src="../../../assets/img/car-loader-white.svg" alt="app-loader" />
        <h3 *ngIf="phrase" class="phrase">{{ phrase }}</h3>
    </div>
</div>
